import { Box, Typography, useTheme } from "@mui/material";
import type React from "react";

interface OnboardingStepLayoutProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}

export const OnboardingStepLayout = ({
  title,
  subtitle,
  children,
}: OnboardingStepLayoutProps): JSX.Element => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: theme.palette.secondary["purple-tint"],
          marginBottom: "8px",
          flexShrink: 0,
        }}
      >
        {title}
      </Typography>
      <Typography
        variant="body-small"
        sx={{
          color: "inherit",
          marginBottom: "32px",
          lineHeight: 1.5,
          flexShrink: 0,
        }}
      >
        {subtitle}
      </Typography>
      <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>{children}</Box>
    </Box>
  );
};
